import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import {
    Container,
    Card
} from 'reactstrap';
import styles from './styles.module.scss';

export default function NewEmployers({
    customClass = "",
    global,
    pathPrefix,
    post,
    locale,

    pathURL = ""
}) {
    return (
        post?.length >= 1 && (
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    <div className="wrapper d-flex flex-wrap">
                        {post?.map((post, index) =>
                            <Card key={index}>
                                <a href={`${locale == "us" ? "/us/" : ""}/job-seekers/${pathURL}${post.url_slug}`}>
                                    {post.tag?.length >= 1 && (
                                        <div className="mb-4">
                                            {post.tag?.map((post, index) =>
                                                <span key={index}>{post}</span>
                                            )}
                                        </div>
                                    )}
                                    <div className="text-center">
                                        <SourceFlowImage
                                            src={post?.logo_image ? post.logo_image : "/site-assets/placeholders/img-placeholder.jpg"}
                                            size="x150"
                                            alt={`Image ${index}`}
                                            className="card-img mb-4"
                                            width="100%"
                                            height="auto"
                                        />
                                    </div>
                                    <div className="post-title">{post.title}</div>
                                </a>
                            </Card>
                        )}
                    </div>
                </Container>
            </section >
        )
    )
}